export function fixPaginationLayout() {
    const node = document.querySelector('.djangocms-newsblog-article-detail ul.pagination')
    if (node && node.querySelectorAll('li').length === 2) {
        node.appendChild(document.createElement('li'))
    }
}
